// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)
